(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eeva-weekend15-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('eeva-weekend15-dialog');
    if (!dialog) return;
    const start = Number(dialog.dataset.start);
    const end = Number(dialog.dataset.end);
    const sessionKey = 'eeva_weekend15_seen';
    const excluded = /\/(?:cart|checkouts?|account)(?:\/|$)/i.test(location.pathname);
    const active = () => Date.now() >= start && Date.now() < end;
    const expire = () => {
      if (dialog.open) dialog.close();
      document.body.classList.remove('eeva-weekend15-active');
    };
    const sync = () => {
      if (active()) document.body.classList.add('eeva-weekend15-active');
      else expire();
    };
    sync();
    if (!active()) return;
    setTimeout(expire, Math.max(0, end - Date.now()));
    document.addEventListener('visibilitychange', sync);
    window.addEventListener('pageshow', sync);
    const seen = () => {
      try { return document.cookie.split(';').some(item => item.trim() === sessionKey + '=1'); }
      catch { return false; }
    };
    const remember = () => {
      try { document.cookie = sessionKey + '=1; Path=/; SameSite=Lax; Secure'; }
      catch { }
    };
    const close = () => { if (dialog.open) dialog.close(); };
    dialog.querySelector('.eeva-weekend15__close').addEventListener('click', close);
    dialog.querySelector('.eeva-weekend15__keep').addEventListener('click', close);
    dialog.querySelector('.eeva-weekend15__copy').addEventListener('click', async () => {
      if (!active()) { expire(); return; }
      const status = dialog.querySelector('.eeva-weekend15__status');
      try {
        await navigator.clipboard.writeText('WEEKEND15');
        status.textContent = dialog.dataset.copied;
      } catch { status.textContent = dialog.dataset.copyFallback; }
    });
    dialog.querySelector('.eeva-weekend15__apply').addEventListener('click', () => {
      if (!active()) { expire(); return; }
      remember();
      const destination = location.pathname + location.search + location.hash;
      location.assign('/discount/WEEKEND15?redirect=' + encodeURIComponent(destination));
    });
    if (excluded || seen() || typeof dialog.showModal !== 'function') return;
    setTimeout(() => {
      if (!active()) { expire(); return; }
      if (seen()) return;
      dialog.showModal();
      remember();
    }, 3000);
  })();
  } catch(e) { console.error(e); }
})();

})();
